export const GOOGLE_TAG_EVENTS = {
  LOGIN: {
    SUBSCRIBER_LOGIN_SUCCESS: "subscriber_login_success",
  },
  PURCHASE: {
    COURSE_PURCHASE_SUCCESS: "course_purchase_success",
    SESSION_PURCHASE_SUCCESS: "session_purchase_success",
  },
};

export const GOOGLE_EVENTS = {
  LOGIN: {
    INSTRUCTOR_LOGIN_SUCCESS: "instructor_login_successful",
  },
  SIGNUP: {
    INSTRUCTOR_SIGNUP_SUCCESS: "instructor_signup_successful",
  },
  SCHEDULE_DEMO: {
    CTA_CLICKED: "schedule_a_demo_cta_clicked",
    FORM_FILLED: "demo_schedule_form_filled",
  },
};
